const HAS_TIMEZONE = /(Z|[+-]\d{2}:?\d{2})$/i;

export function formatKstDateTime(value) {
  if (!value) return "-";

  const raw = String(value).trim();
  const isoLike = raw.replace(" ", "T");
  const date = new Date(HAS_TIMEZONE.test(isoLike) ? isoLike : `${isoLike}+09:00`);

  if (Number.isNaN(date.getTime())) return raw;

  const parts = new Intl.DateTimeFormat("ko-KR", {
    timeZone: "Asia/Seoul",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
//  second: "2-digit",
    hour12: false,
  }).formatToParts(date);
  const get = (type) => parts.find((part) => part.type === type)?.value || "";

  return `${get("year")}.${get("month")}.${get("day")} ${get("hour")}:${get("minute")}`;
}
